// extracted by mini-css-extract-plugin
export default {"divider":"ButtonDivider_divider__R9YK2"};